import { render, staticRenderFns } from "./pronaces.vue?vue&type=template&id=7eda31e7&"
import script from "./pronaces.component.ts?vue&type=script&lang=ts&"
export * from "./pronaces.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports